export default "skymp5-front/a0dbfb543afb4ea53192867cee11c136.png";